module.exports = __webpack_public_path__ + "static/media/got-it.2c9ee980.svg";